module.exports = "<div class=\"statistic-wrapper\">\n    <span class=\"statistic-data\">{{data}}</span>\n    <span class=\"statistic-text\">{{label}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/statictics/statistics.component.html
// module id = 894
// module chunks = 0